import { render, staticRenderFns } from "./token.vue?vue&type=template&id=44124f34&scoped=true&"
import script from "./token.vue?vue&type=script&lang=ts&"
export * from "./token.vue?vue&type=script&lang=ts&"
import style0 from "./token.vue?vue&type=style&index=0&id=44124f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44124f34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VProgressLinear})
